import { render, staticRenderFns } from "./review-deposit-form.component.vue?vue&type=template&id=c08afed6&"
import script from "./review-deposit-form.component.vue?vue&type=script&lang=ts&"
export * from "./review-deposit-form.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports